//(function() {
//    'use strict';

//    angular.module("imApp").factory("componentReplacementsService", [function() {
//        let service = {};

//        return service;
//    }]);
//})();
